import { motion } from "framer-motion";
import { EnvelopeSimple, BellRinging } from "@phosphor-icons/react";

const SECTION_LABELS = {
  app: { email: "Onboarding Email Sequence", push: "Push Notification Sequence" },
  website: { email: "Post-Signup Nurture Emails", push: "Web Push / On-Site Prompts" },
  social_channel: { email: "New Follower Welcome Sequence", push: "Re-Engagement Post Ideas" },
  other: { email: "Onboarding Email Sequence", push: "Re-Engagement Sequence" },
};

const SequenceCard = ({ sequence, testId, productType = "app" }) => {
  if (!sequence) return null;
  const labels = SECTION_LABELS[productType] || SECTION_LABELS.app;

  return (
    <div data-testid={testId} className="glass-panel rounded-3xl p-6 sm:p-10">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#7C93B8] mb-4 flex items-center gap-2">
            <EnvelopeSimple size={16} /> {labels.email}
          </p>
          <div className="space-y-5">
            {(sequence.onboarding_emails || []).map((e, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 10 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.05 }}
                className="border-l-2 border-white/30 pl-4"
              >
                <p className="text-xs font-mono text-white mb-1">{e.day}</p>
                <p className="font-display text-sm font-bold mb-1.5">{e.subject}</p>
                <p className="text-sm text-white/50 leading-relaxed whitespace-pre-line line-clamp-4">{e.body}</p>
              </motion.div>
            ))}
          </div>
        </div>

        <div>
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#7C93B8] mb-4 flex items-center gap-2">
            <BellRinging size={16} /> {labels.push}
          </p>
          <div className="space-y-3">
            {(sequence.push_notifications || []).map((p, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, x: 10 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.05 }}
                className="glass-panel rounded-xl p-4"
              >
                <p className="text-xs font-mono text-[#F97316] mb-1.5">{p.trigger}</p>
                <p className="text-sm text-white/70">{p.text}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SequenceCard;
